import validate from "/Users/ahmadishfaq/ishfaq/github/smartcomm/smartcomm/smartcomm-mono-frontend/node_modules/.pnpm/nuxt@3.6.2_@types+node@18.16.19_eslint@8.44.0_magicast@0.3.5_optionator@0.9.3_rollup@3.26.2_t_bnuln4gij2zdpg3hn5557sxteu/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}